module.exports = {
      id: "bondhushava-usage",
      viewBox: "0 0 225 61",
      url: "/" + "sprite-f96a299a5e63739e5b36582e48c149a3.svg#bondhushava",
      toString: function () {
        return this.url;
      }
    }